import Clipboard from './Clipboard/clipboard';
import loadMore from './loadMore';
import autoVideo from './auto-video';
import drap from './drap';

export const clipboard = Clipboard;

export default {
  loadMore,
  Clipboard,
  autoVideo,
  drap
};
